// ============================================================
// หน้า ImportCustomer — นำเข้าไฟล์ข้อมูล : รายชื่อลูกค้า
// ------------------------------------------------------------
// ขั้นตอน
//   1. ผู้ใช้ลากวาง/เลือกไฟล์ Excel (ต้องเป็นชีตชื่อ "นำเข้าข้อมูลลูกค้า")
//   2. ระบบตรวจหัวคอลัมน์ให้ตรงกับ template ก่อน ถ้าไม่ตรงจะบอกว่าคอลัมน์ไหนผิด
//   3. แปลงข้อมูลเป็นรายการลูกค้า แล้วแสดงตารางให้ตรวจก่อน (ช่องที่ขาดจะไฮไลต์แดง)
//   4. กด "นำเข้า" ถึงจะบันทึกลงระบบจริง
//
// ข้อกำหนดของไฟล์ (หัวคอลัมน์ / ตารางแปลงค่า) อยู่ที่ components/custom/customer-excel.js
// ใช้ร่วมกับ popup นำเข้าในหน้า Customer
// ============================================================

import React, { Component } from "react";
import { ReactExcel, readFile, generateObjects } from "@ramonak/react-excel";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar.js";
import excel_file from "../../assets/files/import_customer.xlsx";
import {
  tokens,
  success_url,
  alert,
  toFixed,
  POST,
  format_date,
  getStorage,
  loading,
  ExcelDropZone,
  ScrollTopButton,
  ActionIcon,
  ICON,
} from "../../shared/index.js";
import { CUSTOMER_SHEET_NAME, TRANSFER_FROM_TEXT, BUY_FROM_TEXT, transferText, buyText, findInvalidColumn, padLeftDigits } from "../../shared/domain/customer-excel.js";

// แถวตัวอย่างในไฟล์ template ที่ต้องไม่ถูกนำเข้า
const SAMPLE_ROW_NAME = "ตัวอย่าง ข้อมูล";

export default class Import extends Component {
  state = {
    import: null, // ไฟล์ที่อ่านเข้ามา (ส่งให้ ReactExcel แปลง)
    currentSheet: null, // ชีตที่ ReactExcel แปลงเสร็จแล้ว
    data_import: null, // รายการลูกค้าที่เตรียมนำเข้า
  };

  componentDidMount() {
    loading(false);
  }

  // ---------- อ่านไฟล์ ----------

  // รับไฟล์จาก ExcelDropZone (ได้ทั้งลากวางและเลือกไฟล์)
  // ต้องเป็นชีตชื่อ "นำเข้าข้อมูลลูกค้า" เท่านั้น
  handleFile = (file) => {
    readFile(file)
      .then((readedData) => {
        if (readedData.SheetNames[0] !== CUSTOMER_SHEET_NAME) {
          alert("info", "แจ้งเตือน", "ไฟล์ไม่ถูกต้อง");
          return;
        }
        // รอ 10ms ให้ ReactExcel อัปเดต currentSheet ก่อนอ่านข้อมูล
        this.setState({ import: readedData }, () => setTimeout(this.Import, 10));
      })
      .catch(console.error);
  };

  // ตรวจหัวคอลัมน์ + แปลงชีตเป็นรายการลูกค้า
  Import = () => {
    loading(true);

    const invalidColumn = findInvalidColumn(this.state.currentSheet[CUSTOMER_SHEET_NAME][0]);
    if (invalidColumn) {
      alert("warning", "แจ้งเตือน", `หัวคอลัมน์ "${invalidColumn}" ไม่ถูกต้อง`);
      loading(false);
      return;
    }

    const data = generateObjects(this.state.currentSheet)
      // ต้องมีชื่อ และไม่ใช่แถวตัวอย่างในไฟล์ template
      .filter((item) => item["ชื่อ - สกุล"] && item["ชื่อ - สกุล"] !== SAMPLE_ROW_NAME)
      .map((item) => ({
        full_name: item["ชื่อ - สกุล"]?.toString().trim() || "",
        id_card: padLeftDigits(item["เลขบัตรประชาชน"], 13),
        address: item["ที่อยู่"] || "",
        home_phone: (item["โทรศัพท์บ้าน"] || "").toString().replace(/-/g, ""),
        mobile_phone: item["โทรศัพท์มือถือ"] ? padLeftDigits(item["โทรศัพท์มือถือ"].toString().replace(/-/g, ""), 10) : "",
        delivery_date: item["วันที่ส่งมอบ"] || null,
        receive_date: item["วันที่มารับมอบ"] || null,
        transfer_date: item["วันที่โอน"] || null,
        status_transfer: TRANSFER_FROM_TEXT[item["สถานะการโอน"]] || 0,
        loan_number: (item["เลขที่เงินกู้"] || "").toString(),
        credit_limit: item["วงเงินกู้"] || 0,
        installment: item["เงินงวด"] || 0,
        contract_date: item["วันที่ทำสัญญา"] || null,
        status_buy_building: BUY_FROM_TEXT[item["ซื้ออาคารโดย"]] || 0,
        address_number: (item["บ้านเลขที่"] || "").toString(),
        building: item["อาคาร"] || "",
        floor: item["ชั้น"] || "",
        room_size: item["ขนาดห้อง (ตรม.)"] || "",
        status_cable: false,
      }));

    this.setState({ data_import: data.length ? data : null });
    loading(false);
  };

  // ---------- บันทึก ----------

  Create_Import = async () => {
    loading(true);
    const result = await POST(tokens, `v1/TH/customer-manage/create/${getStorage("project_id")}`, { customer_list: this.state.data_import });
    if (result?.status) success_url("/customer");
    loading(false);
  };

  // ลบ 1 แถวออกจากตารางตรวจสอบ (ลบหมดแล้วกลับไปหน้าเลือกไฟล์)
  removeRow = (index) => {
    const data = this.state.data_import.filter((_, i) => i !== index);
    this.setState({ data_import: data.length ? data : null });
  };

  render() {
    const { data_import } = this.state;

    // ช่องข้อมูลที่ "ต้องมีค่า" — ถ้าว่างจะไฮไลต์พื้นแดงให้ผู้ใช้เห็นก่อนนำเข้า
    const tdRequired = (value) => <td className={value ? "text-left" : "text-left bg-danger-light"}>{value || "-"}</td>;
    const tdDate = (value) => <td className="text-left">{value ? format_date(value, "dd/mm/yyyy") : "-"}</td>;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="นำเข้าไฟล์ข้อมูล" page3="รายชื่อลูกค้า" />
        <div className="body">
          <div className="p-3">
            {/* หัวข้อ + ปุ่มย้อนกลับ/ล้างค่า/นำเข้า */}
            <div className="w-100 d-flex justify-content-between mb-3">
              <h4 className="mb-3">
                <b>นำเข้าไฟล์ข้อมูล : รายชื่อลูกค้า</b>
              </h4>
              <div className="d-flex">
                <button className="btn btn-outline-primary wpx-150 mx-1" onClick={() => (window.location.href = "/import")}>
                  <span className="icon-brand mr-2">{ICON.back}</span>ย้อนกลับ
                </button>
                {data_import && (
                  <button className="btn btn-danger wpx-150 mx-1" onClick={() => this.setState({ data_import: null })}>
                    ล้างค่า
                  </button>
                )}
                {data_import && (
                  <button className="btn btn-primary wpx-150 mx-1" onClick={this.Create_Import}>
                    นำเข้า
                  </button>
                )}
              </div>
            </div>

            {/* ยังไม่ได้เลือกไฟล์ → กล่องลากวาง | เลือกแล้ว → ตารางตรวจสอบข้อมูล */}
            {!data_import ? (
              <ExcelDropZone variant="page" templateFile={excel_file} templateName="import_customer.xlsx" templateLabel="template นำเข้าข้อมูลลูกค้า" onFile={this.handleFile} />
            ) : (
              <div className="card border-0 mb-3">
                <div className="card-header bg-dark-blue px-3 rounded-top">
                  <h4 className="text-white mb-0">
                    <b>ข้อมูลนำเข้า</b>
                  </h4>
                </div>
                <div className="p-3">
                  <label>จำนวนที่นำเข้า {data_import.length} รายการ</label>
                  <div className="table-responsive">
                    <table className="table text-nowrap">
                      <thead>
                        <tr className="bg-dark-blue text-white">
                          <th className="text-left wpx-150">ชื่อ - สกุล</th>
                          <th>เลขบัตรประชาชน</th>
                          <th className="wpx-200">ที่อยู่</th>
                          <th>โทรศัพท์บ้าน</th>
                          <th>โทรศัพท์มือถือ</th>
                          <th>วันที่ส่งมอบ</th>
                          <th>วันที่มารับมอบ</th>
                          <th>วันที่โอน</th>
                          <th className="wpx-120">สถานะการโอน</th>
                          <th>เลขที่เงินกู้</th>
                          <th>วงเงินกู้</th>
                          <th>เงินงวด</th>
                          <th>วันที่ทำสัญญา</th>
                          <th className="wpx-170">ซื้ออาคารโดย</th>
                          <th>อาคาร</th>
                          <th>ชั้น</th>
                          <th>บ้านเลขที่</th>
                          <th>ขนาดห้อง (ตรม.)</th>
                          <th>ลบ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data_import.map((item, i) => (
                          <tr key={i}>
                            {tdRequired(item.full_name)}
                            <td className="text-left">{item.id_card || "-"}</td>
                            <td className="text-left">{item.address || "-"}</td>
                            <td className="text-left">{item.home_phone || "-"}</td>
                            <td className="text-left">{item.mobile_phone || "-"}</td>
                            {tdDate(item.delivery_date)}
                            {tdDate(item.receive_date)}
                            {tdDate(item.transfer_date)}
                            <td className="text-left">{transferText(item.status_transfer)}</td>
                            <td className="text-left">{item.loan_number || "-"}</td>
                            <td className="text-left">{item.credit_limit ? toFixed(item.credit_limit) : "-"}</td>
                            <td className="text-left">{item.installment ? toFixed(item.installment) : "-"}</td>
                            {tdDate(item.contract_date)}
                            <td className="text-left">{buyText(item.status_buy_building)}</td>
                            {tdRequired(item.building)}
                            {tdRequired(item.floor)}
                            {tdRequired(item.address_number)}
                            <td className="text-left">{item.room_size || "-"}</td>
                            <td className="text-center">
                              <ActionIcon color="danger" icon={ICON.delete} title="ลบแถวนี้" className="mx-auto mb-0" onClick={() => this.removeRow(i)} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* ตัวแปลงไฟล์ Excel ของ library — ซ่อนไว้ ไม่ได้ให้ผู้ใช้เห็น */}
            <div className="d-none">
              <ReactExcel initialData={this.state.import} onSheetUpdate={(s) => this.setState({ currentSheet: s })} activeSheetClassName="d-none" />
            </div>
          </div>
        </div>

        <ScrollTopButton />
      </div>
    );
  }
}
